import { Expose, Type } from '@nts/std/serialization';
import { UserLayoutGridMetaData } from "./user-layout-grid-meta-data";
import { UserPanelMetaData } from "./user-panel-meta-data";
import { UserLayoutGridMetaDataInterface, UserLayoutMetaDataInterface, UserPanelMetaDataInterface } from '@nts/std/interfaces';

export class UserLayoutMetaData implements UserLayoutMetaDataInterface {

    constructor() {
        this.panels = [];
        this.grids = [];
    }

    @Expose()
    @Type(() => UserPanelMetaData)
    panels: UserPanelMetaDataInterface[]

    @Expose()
    @Type(() => UserLayoutGridMetaData)
    grids: UserLayoutGridMetaDataInterface[]
}
